import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import CreateProfileForm from "../../forms/CreateProfileForm";
import './styles.scss';

export class  CreateProfile extends React.Component {

  getInitialEmailValue = () => {

  };

  getInitialEmailValue = () => {

  };

  getInitialValues = profile => {
      return {
        ...profile,
        first_name: profile.first_name,
        last_name: profile.last_name,
        addresses: [
          {
            "street_number": "",
            "unit_number": "",
            "street": "",
            "neighbourhood": "",
            "country": profile.country,
            "state_prov": "",
            "city_district": profile.city,
            "postal_zip": "",
            "other": null,
            "category": "Home",
            "order_index": 0,
            "street_number_privacy": "MC",
            "unit_number_privacy": "MC",
            "street_privacy": "MC",
            "neighbourhood_privacy": "MC",
            "country_privacy": "PU",
            "state_prov_privacy": "PU",
            "city_district_privacy": "PU",
            "postal_zip_privacy": "MC",
            "other_privacy": "MC"
          }
        ],
        email_addresses: [
          {
            address: profile.email,
            privacy: "PU",
            category: "Home",
            order_index: 0,
          }
        ],
      }
  };

  render() {
    const { profile } = this.props;

    return (
      <div id="page-container" className="row align-items-center justify-content-center">
        <div id="create-profile-container" className="row">
          <div className="col-12">
            <CreateProfileForm
              initialValues={this.getInitialValues(profile)}
              slug={profile.slug}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(({ profile }) => ({
  profile: profile.profile,
}))( CreateProfile));


// WEBPACK FOOTER //
// ./src/components/pages/CreateProfile/CreateProfile.jsx